/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetEquipmentBulkEditViewRequest = {
  /**
   * The device kind to get the bulk edit view for
   */
  deviceKind: string;
  /**
   * Optional filter of device ids to include in the bulk edit view
   */
  deviceIds?: Array<string> | undefined;
  agentId: string;
};

/** @internal */
export type GetEquipmentBulkEditViewRequest$Outbound = {
  device_kind: string;
  device_ids?: Array<string> | undefined;
  agent_id: string;
};

/** @internal */
export const GetEquipmentBulkEditViewRequest$outboundSchema: z.ZodType<
  GetEquipmentBulkEditViewRequest$Outbound,
  z.ZodTypeDef,
  GetEquipmentBulkEditViewRequest
> = z.object({
  deviceKind: z.string(),
  deviceIds: z.array(z.string()).optional(),
  agentId: z.string(),
}).transform((v) => {
  return remap$(v, {
    deviceKind: "device_kind",
    deviceIds: "device_ids",
    agentId: "agent_id",
  });
});

export function getEquipmentBulkEditViewRequestToJSON(
  getEquipmentBulkEditViewRequest: GetEquipmentBulkEditViewRequest,
): string {
  return JSON.stringify(
    GetEquipmentBulkEditViewRequest$outboundSchema.parse(
      getEquipmentBulkEditViewRequest,
    ),
  );
}
